import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    confirm: 'Yes, mark as accepted',
    errorMessage:
      'An error occurred while editing your quote. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    title: 'Do you really want to mark this quote as accepted?',
  },
  fr: {
    cancel: 'Annuler',
    confirm: 'Oui, marquer comme accepté',
    errorMessage:
      'Une erreur est survenue lors la modification de votre devis. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    title: 'Voulez-vous vraiment marquer ce devis comme accepté\xA0?',
  },
} as const);
